import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import AppLayout from "@/components/AppLayout";
import { LoginPage, RegisterPage } from "@/pages/AuthPages";
import DashboardPage from "@/pages/DashboardPage";
import SubmitHoursPage from "@/pages/SubmitHoursPage";
import MyHoursPage from "@/pages/MyHoursPage";
import ApproveHoursPage from "@/pages/ApproveHoursPage";
import ManageUsersPage from "@/pages/ManageUsersPage";
import CommitteesPage from "@/pages/CommitteesPage";
import AuditLogPage from "@/pages/AuditLogPage";
import ReportsPage from "@/pages/ReportsPage";
import ProfilePage from "@/pages/ProfilePage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordResetPages";
import KioskPage from "@/pages/KioskPage";

function AppRouter() {
  const location = useLocation();

  // Check for Google OAuth code in URL params (redirect back from Google)
  const searchParams = new URLSearchParams(location.search);
  if (searchParams.get('code') && location.pathname === '/dashboard') {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/kiosk" element={<KioskPage />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <AppLayout><DashboardPage /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/submit-hours" element={
        <ProtectedRoute>
          <AppLayout><SubmitHoursPage /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/my-hours" element={
        <ProtectedRoute>
          <AppLayout><MyHoursPage /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/approve-hours" element={
        <ProtectedRoute roles={['supervisor', 'admin']}>
          <AppLayout><ApproveHoursPage /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/manage-users" element={
        <ProtectedRoute roles={['admin']}>
          <AppLayout><ManageUsersPage /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/committees" element={
        <ProtectedRoute roles={['admin']}>
          <AppLayout><CommitteesPage /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/audit-log" element={
        <ProtectedRoute roles={['admin']}>
          <AppLayout><AuditLogPage /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/reports" element={
        <ProtectedRoute>
          <AppLayout><ReportsPage /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute>
          <AppLayout><ProfilePage /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
